import { useEffect } from 'react'
import { Outlet, ScrollRestoration, useLocation, useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import Seo from 'components/Seo'
import Header from 'components/Header'
import Footer from 'components/Footer'
import getLocalizedPath from 'utils/localizedPath'

export default function Main() {
    const {
        i18n: { language },
    } = useTranslation()
    const location = useLocation()
    const navigate = useNavigate()

    useEffect(() => {
        const nextLanguage = language === 'zh' ? 'zh' : 'en'
        const currentPath = `${location.pathname}${location.search}`
        const localizedPath = getLocalizedPath(currentPath, nextLanguage)

        if (currentPath !== localizedPath) {
            navigate(localizedPath, { replace: true })
        }
    }, [language, location.pathname, location.search, navigate])

    return (
        <div
            style={{ fontFamily: "Barlow, 'gf_Noto_Sans_SC', sans-serif" }}
            id='main-container'
        >
            <Seo />
            <Header />
            <main className='pt-[53.8px]'>
                <Outlet />
            </main>
            <ScrollRestoration />
            <Footer />
        </div>
    )
}
